import ApplicationAdapter from "./application";

export default class EmailAccountAdapter extends ApplicationAdapter {
  urlForCreateRecord(_, snapshot) {
    let project = snapshot.belongsTo("domain").belongsTo("project");
    let organization = project.belongsTo("organization");
    return `${this.apiBaseUri}/email/createaccount?organizationnumber=${organization.id}&projectkey=${project.id}`;
  }

  urlForUpdateRecord() {
    let [, , snapshot] = arguments;
    let project = snapshot.belongsTo("domain").belongsTo("project");
    let organization = project.belongsTo("organization");
    return `${this.apiBaseUri}/email/editaccount?organizationnumber=${organization.id}&projectkey=${project.id}`;
  }

  urlForDeleteRecord(id, _, snapshot) {
    let project = snapshot.belongsTo("domain").belongsTo("project");
    return `${this.apiBaseUri}/email/delete?email=${id}&projectkey=${project.id}`;
  }
}
